import React from 'react';
import {useDispatch} from 'react-redux';
import Popup from '../../index';
import {
	customFieldDeletionConfirmationPopup,
	deleteCustomField,
	submitCustomField as setSubmitCustomField
} from '../../../../../actions/customFieldsActions';
import Button from '../../../button';
import Icon from '../../../icon';

function CustomFieldDeletionConfirmationPopup ({id}) {

	const dispatch = useDispatch();

	const close = () => {
		dispatch(customFieldDeletionConfirmationPopup(null))
	};

	const handleClick = () => {
		dispatch(setSubmitCustomField(id));
		dispatch(deleteCustomField(id));
		dispatch(customFieldDeletionConfirmationPopup(null));
	};

	return (
		<Popup className="p-4" onClose={close}>
			<h2 className="text-danger"><Icon name="warning" className="text-danger"/> Custom field deletion</h2>
			<p>Are you sure you want to delete this custom field? The data contained in this field will be removed from all the contacts.</p>
			<div className="text-right mt-4">
				<Button onClick={ handleClick } type="button" className="btn-primary">Confirm</Button>
			</div>
		</Popup>
	)
}

export default CustomFieldDeletionConfirmationPopup;
